// extracted by mini-css-extract-plugin
module.exports = {"label":"SmsCheckbox-module__label___2sRWD","checkboxContainer":"SmsCheckbox-module__checkboxContainer___2plqr","text":"SmsCheckbox-module__text___3wKGN"};